var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.modalData
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalData,
                expression: "modalData",
              },
            ],
            ref: "modal",
            attrs: {
              onModalClose: _vm.onModalClose,
              onModalAccept: _vm.removeSelected,
              modalData: _vm.modalData,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-warning", on: { click: _vm.deleteModal } },
        [_vm._v("Удалить выбранные")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }